<template>
  <b-overlay :show="loading" rounded="sm">
    <b-row>
      <b-col>
        <b-card title="جزئیات مقاله">
          <b-form-radio-group v-model="Form.BlogContentType" :options="enums('BlogContentType')" class="mt-1" />
          <b-tabs card>
            <b-tab>
              <template #title>
                <feather-icon icon="UserIcon" />
                <span class="d-none d-sm-inline">اطلاعات مقاله</span>
              </template>
              <b-row>
                <b-col class="mt-2 form-size" md="8">
                  <b-row>
                    <b-col cols="12" class="d-flex mb-1">
                      <upload-file v-if="Form.BlogContentType === 0" v-model="Form.Image" label="عکس مقاله" />
                      <upload-file v-if="Form.BlogContentType === 1" v-model="Form.Image" label="عکس پیشنمایش ویدیو" />
                      <upload-file v-if="Form.BlogContentType === 1" v-model="Form.Video" label="ویدیو"
                        :is-video="true" />
                    </b-col>
                    <b-col md="8">
                      <b-form-group label="عنوان" label-for="Title">
                        <b-form-input id="Title" v-model="Form.Title" name="Title" autocomplete="off" />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group label="ترتیب" label-for="Sort">
                        <b-form-input id="Sort" v-model="Form.Sort" name="Sort" type="number" autocomplete="off" />
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="URL : از علامت سوال استفاده نشود" label-for="Url">
                        <b-input-group id="url"
                          :prepend="`https://zirehapp.com/blog/${temp_categorySelected.LatinTitle}/articleId/`"
                          class="input-group-url">
                          <b-form-input v-model="Form.Url" autocomplete="off" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="وضعیت" label-for="Visibility">
                        <v-select v-model="Form.Visibility" :options="enums('IsActive')" dir="rtl" label="text"
                          :clearable="false" :reduce="x => x.value" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="مجله" label-for="Type">
                        <v-select v-model="Form.Type" :options="enums('Company')" dir="rtl" label="text"
                          :clearable="false" :reduce="x => x.value" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="دسته بندی" label-for="BlogCategoryId">
                        <z-blog-category v-model="Form.BlogCategoryIds" :multiple="false" :type="Form.Type"
                          @selected="temp_categorySelected = $event" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="مدت زمان مطالعه (دقیقه)" label-for="ReadingDuration">
                        <b-form-input id="Sort" v-model="Form.ReadingDuration" name="ReadingDuration" type="number"
                          autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="مدت زمان مطالعه (دقیقه)" label-for="ReadingDuration">
                        <b-form-input id="Sort" v-model="Form.ReadingDuration" name="ReadingDuration" type="number"
                          autocomplete="off" />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="editing">
              <template #title>
                <feather-icon icon="UserIcon" />
                <span class="d-none d-sm-inline">مقاله به زبان های مختلف</span>
              </template>
              <b-row>
                <b-col md="8" class="form-size">
                  <b-row v-for="(item, index) in languages" :key="index" class="mb-1 border p-1 m-0">
                    <b-col md="11" class="">
                      <b-row>
                        <b-col md="6">
                          <b-form-group label="زبان">
                            <z-language v-model="item.Language" :unselectable="languages.map(i => i.Language)" />
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group label="عنوان">
                            <b-form-input id="Title" v-model="item.Title" name="Title" autocomplete="off" />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group label="تگ ها" label-for="Tags">
                            <b-form-tags v-model="item.Tags" name="UserIds" input-id="UserIds"
                              duplicate-tag-text="این شناسه تکراری است" placeholder="" :number="false"
                              add-button-text="اضافه" add-button-variant="outline-primary" />
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group label="خلاصه" label-for="BriefDescription">
                            <b-form-textarea id="BriefDescription" v-model="item.BriefDescription"
                              name="BriefDescription" rows="6" no-resize />
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group label="متن " label-for="Description">
                            <quill-editor id="Descriptiont" v-model="item.Description" :options="snowOption"
                              @change="setEventElement" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="1" class="d-flex flex-column align-items-center justify-content-center">
                      <b-button v-if="deleting === item.Language" class="btn-icon mb-1" size="sm"
                        @click="deleting = null">
                        <feather-icon icon="XIcon" />
                      </b-button>
                      <template v-else>
                        <b-button v-if="item.new" variant="primary" class="btn-icon mb-1" size="sm"
                          @click="updateLanguage(item)">
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                        <b-button v-else variant="primary" class="btn-icon mb-1" size="sm"
                          @click="updateLanguage(item)">
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                      </template>
                      <b-button v-if="deleting === item.Language" variant="danger" class="btn-icon" size="sm"
                        @click="removeLanguage(item, index)">
                        <feather-icon icon="CheckIcon" />
                      </b-button>
                      <b-button v-else variant="danger" class="btn-icon" size="sm" @click="deleting = item.Language">
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-center">
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="gradient-info"
                      @click="addBlogLanguage">
                      <feather-icon icon="PlusIcon" class="mr-25" />
                      <span>افزودن</span>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="seo">
              <template #title>
                <feather-icon icon="UserIcon" />
                <span class="d-none d-sm-inline">seo</span>
              </template>
              <b-row>
                <b-col class="mt-2 form-size" md="8">
                  <b-row>
                    <b-col md="12">
                      <b-form-group label="alt image" label-for="altImage">
                        <b-form-input id="altImage" v-model="Form.ImageAlt" name="altImage" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="meta title" label-for="MetaTitle">
                        <b-form-input id="MetaTitle" v-model="Form.MetaTitle" name="MetaTitle" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="canonical" label-for="canonical">
                        <b-input-group id="canonical">
                          <b-form-input v-model="Form.Canonical" autocomplete="off" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-radio-group v-model="Form.IndexPost"
                        :options="[{ value: true, text: 'index' }, { value: false, text: 'no index' }]" class="mt-1 mb-1" />
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="meta description" label-for="metaDescription">
                        <b-form-textarea id="metaDescription" v-model="Form.MetaDescription" name="metaDescription"
                          rows="8" no-resize />
                      </b-form-group>
                    </b-col>
                    <!--                    <b-col md="12">-->
                    <!--                      <b-card title="Schemas" border-variant="secondary">-->
                    <!--                        <b-row>-->
                    <!--                          <b-col>-->
                    <!--                            <template v-for="(schema,index) in Schemas">-->
                    <!--                              <b-card>-->
                    <!--                                <b-row>-->
                    <!--                                  <b-col md="10">-->
                    <!--                                    <b-form-group-->
                    <!--                                        label="schema"-->
                    <!--                                        label-for="schema"-->
                    <!--                                    >-->
                    <!--                                      <b-form-textarea-->
                    <!--                                          id="schema"-->
                    <!--                                          :value="schema"-->
                    <!--                                          @input="(value)=>{Schemas[index]=value}"-->
                    <!--                                          name="schema"-->
                    <!--                                          rows="8"-->
                    <!--                                          class="dir-ltr"-->
                    <!--                                          no-resize-->
                    <!--                                      />-->
                    <!--                                    </b-form-group>-->
                    <!--                                  </b-col>-->
                    <!--                                  <b-col md="2">-->
                    <!--                                    <b-button-->
                    <!--                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"-->
                    <!--                                        variant="outline-danger"-->
                    <!--                                        class="btn-icon rounded-circle mt-5"-->
                    <!--                                        @click="()=>{Schemas.splice(index,1)}"-->
                    <!--                                    >-->
                    <!--                                      <feather-icon-->
                    <!--                                          icon="TrashIcon"-->
                    <!--                                      />-->
                    <!--                                    </b-button>-->
                    <!--                                  </b-col>-->
                    <!--                                </b-row>-->
                    <!--                              </b-card>-->
                    <!--                            </template>-->
                    <!--                          </b-col>-->
                    <!--                          <b-col cols="12">-->
                    <!--                            <b-button-->
                    <!--                                variant="info"-->
                    <!--                                class="ml-1"-->
                    <!--                                @click="()=>{Schemas.push('')}"-->
                    <!--                            >-->
                    <!--                              <feather-icon-->
                    <!--                                  icon="PlusIcon"-->
                    <!--                              />-->
                    <!--                              اسکیما-->
                    <!--                            </b-button>-->
                    <!--                          </b-col>-->
                    <!--                        </b-row>-->
                    <!--                      </b-card>-->
                    <!--                    </b-col>-->
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="FAQ">
              <template #title>
                <feather-icon icon="UserIcon" />
                <span class="d-none d-sm-inline">سوالات متداول</span>
              </template>
              <b-row v-for="(item, index) in Faqs" :key="index" ref="FAQ"
                class="border-1 border-primary p-2 rounded-lg mb-2">
                <div class="w-100">
                  <div class="float-right">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger"
                      class="btn-icon rounded-circle" @click="Faqs.splice(index, 1)">
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </div>
                <b-col md="12">
                  <b-form-group label="سوال" label-for="Title">
                    <b-form-textarea id="Title" v-model="item.Title" name="metaDescription" rows="2" no-resize />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="پاسخ" label-for="metaDescription">
                    <quill-editor id="metaDescription" v-model="item.Description" :options="snowOption"
                      name="metaDescription" @change="setEventElement" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="gradient-info" class="mb-1"
                @click="addFAQ()">
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>افزودن</span>
              </b-button>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <b-col md="12" class="mt-1 mb-2 text-center">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click="save">
          ذخیره
        </b-button>
        <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" @click="back">
          بازگشت
        </b-button>
      </b-col>
    </b-row>
    <b-modal v-model="showModalImageAttr" ok-title="ذخیره" cancel-title="انصراف" cancel-variant="outline-secondary"
      centered title="اضافه کردن  attribute به عکس" :no-close-on-backdrop="true" size="sm" @ok="addImageAttr">
      <b-row>
        <b-col md="12">
          <b-form-group label="Alt" label-for="Alt">
            <b-form-input id="Alt" v-model="AltTemp" name="Title" autocomplete="off" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="showModalLinkAttr" :ok-title="$t('common.save')" :cancel-title="$t('common.cancel')"
      cancel-variant="outline-secondary" centered title="اضافه کردن  attribute به لینک" :no-close-on-backdrop="true"
      size="md" @ok="setRelAttr">
      <b-row>
        <b-col md="12">
          <h6>آیا این لینک توسط موتور جستجو دنبال بشود؟</h6>

          <b-form-group>
            <v-select v-model="selectedRel" dir="rtl" label="title" :options="enums('RelValues')" :clearable="false"
              @option:selectedRel="onSelectRelOption">
              <span slot="no-options" @click="$refs.select.open = false">
                {{ $t('common.noOptions') }}
              </span>
              <template #option="{ title, value }">
                {{ title }}({{ value.length ? value : 'بدون مقدار' }})
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-overlay>
</template>

<script>

import ZBlogCategory from '@/tools/blogcategory.vue'
import { quillEditor } from 'vue-quill-editor'
import uploadFile from '@/tools/uploadFile'
import faqSelector from '@/tools/faqSelector.vue'

const converter = require('json-2-csv')

export default {
  name: 'BlogDetails',
  components: {
    quillEditor,
    ZBlogCategory,
    uploadFile,
    faqSelector,
  },
  data() {
    return {
      selectedRel: '',
      linkNodeBeforeChange: '',
      tempDescription: '',

      Schemas: [],
      temp_categorySelected: { LatinTitle: 'دسته بنی' },
      Faqs: [],
      Form: {
        Id: 0,
        Title: '',
        MetaTitle: '',
        Description: '',
        Image: null,
        Video: null,
        Visibility: true,
        BlogCategoryIds: [],
        Tags: [],
        BriefDescription: '',
        MetaDescription: '',
        ImageAlt: '',
        Canonical: '',
        IndexPost: true,
        Schemas: [],
        Type: 0,
        Url: '',
        BlogContentType: 0,
        Sort: 0,
        ReadingDuration: 0,
      },
      loading: false,
      snowOption: {
        theme: 'snow',
        // modules: {
        //   toolbar: ['bold', 'italic', 'underline','image','header','align','link','color','indent', 'list']
        // },
      },
      showModalImageAttr: false,
      showModalLinkAttr: false,
      AltTemp: null,
      elementTemp: null,
      languages: [],
      language: {
        BlogId: this.$route.params.id,
        Language: null,
        Title: '',
        Description: '',
        BriefDescription: '',
        Tags: [],
        Type: 0,
        new: true,
      },
      deleting: '',
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    },
  },
  created() {
    if (this.editing) {
      this.Form.Id = this.editing
      this.get()
    }
  },
  methods: {
    onSelectRelOption($evt) {
      console.info($evt)
    },
    save() {
      let url = this.$api.blog.add
      if (this.editing) {
        url = this.$api.blog.update
      }
      this.Form.Schemas = this.Schemas
      delete this.Form.BlogLanguageList
      const formData = new FormData()
      Object.keys(this.Form).forEach(key => {
        if (Array.isArray(this.Form[key])) {
          this.Form[key].forEach((item, index) => {
            if (item !== null) {
              formData.append(`${key}[${index}]`, item)
            }
          })
        } else if (this.Form[key] !== null) {
          formData.append(`${key}`, this.Form[key])
        }
      })
      this.Faqs.forEach((item, index) => {
        if (item !== null) {
          formData.append(`BlogFaqs[${index}].Title`, item.Title)
          formData.append(`BlogFaqs[${index}].Description`, item.Description)
        }
      })
      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClickImg(e) {
      this.elementTemp = e
      this.AltTemp = this.elementTemp.target.getAttribute('alt')
      this.showModalImageAttr = true
    },
    onClickLink(e) {
      // find rel value from elements rel attribute.
      this.selectedRel = this.findRelFromRelValues(e.target.relList.value)
      this.linkNodeBeforeChange = e.target.outerHTML
      this.elementTemp = e
      this.showModalLinkAttr = true
    },
    findRelFromRelValues(elmRelValue) {
      const relValues = this.enums('RelValues')
      try {
        return relValues.find(i => i.value == elmRelValue)
      } catch (err) {
        return relValues.find(i => i.value == '')
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.blog.get, {
        Id: this.Form.Id,
      },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Schemas = this.Form.Schemas
          this.languages = res.data.BlogLanguageList.map(item => ({
            BlogId: res.data.Id,
            BriefDescription: item.BriefDescription,
            Description: item.Description,
            Language: item.Language,
            Title: item.Title,
            Tags: item.Tag.split(';'),
            Type: 0,
          }))
          if (res.data.BlogFaqs.length) this.Faqs = res.data.BlogFaqs
          this.setEventElement()
        })
    },
    setEventElement() {
      this.$nextTick(() => {
        // faq tab => metaDescription img
        document.querySelectorAll('#metaDescription img').forEach(img => {
          img.addEventListener('click', this.onClickImg)
        })
        // faq faq tab => metaDescription a
        document.querySelectorAll('#metaDescription a').forEach(img => {
          img.addEventListener('click', this.onClickLink)
        })

        document.querySelectorAll('#Descriptiont img').forEach(img => {
          img.addEventListener('click', this.onClickImg)
        })
        document.querySelectorAll('#Descriptiont a').forEach(img => {
          img.addEventListener('click', this.onClickLink)
        })
      })
    },
    addImageAttr() {
      this.elementTemp.target.setAttribute('alt', this.AltTemp)
      this.showModalImageAttr = false
    },
    // set <a> rel attribute.
    setRelAttr() {
      this.elementTemp.target.setAttribute('rel', this.selectedRel.value)
      // this.showModalImageAttr = false

      // get Descriptions
      this.tempDescription = this.languages[0].Description
      // get prev elements html
      const oldData = this.linkNodeBeforeChange
      // get new elements html
      const newData = this.elementTemp.target.outerHTML
      // replace old with new.
      this.tempDescription = this.tempDescription.replace(oldData, newData)
      this.languages[0].Description = this.tempDescription
      // set images and links event handlers.
      this.setEventElement()
    },
    // because of updating path of saving rel.
    // closeLinkAttrModal(){
    // this.elementTemp.target.removeAttribute('rel')
    // },
    addBlogLanguage() {
      this.languages.push({ ...this.language })
    },
    updateLanguage(item) {
      let data = { ...item }

      if (this.tempDescription?.length) data = { ...item, ...{ Description: this.tempDescription } }

      delete data.new
      for (const i in data) {
        if (data[i] === '' || data[i] === null || data[i].length === 0) {
          return this.$bvToast.toast('لطفا همه فیلد ها را پر کنید', {
            title: 'خطا در انجام عملیات',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: false,
            appendToast: true,
          })
        }
      }
      this.loading = true
      const url = item.new ? this.$api.blog.addLanguageInfo : this.$api.blog.editLanguageInfo
      this.$http.post(url, data)
        .then(() => {
          // empty temporary descriptio container.
          this.tempDescription = ''

          this.loading = false
          item.new = false
        }).catch(() => {
          this.loading = false
        })
    },
    removeLanguage(item, index) {
      if (item.new) return this.languages.splice(index, 1)
      this.loading = true
      this.$http.post(
        this.$api.blog.removeLanguageInfo, { BlogId: this.editing, Language: item.Language },
      ).then(() => {
        this.loading = false
        const index = this.languages.findIndex(i => i.Language === item.Language)
        if (index !== -1) this.languages.splice(index, 1)
      }).catch(() => {
        this.deleting = null
        this.loading = false
      })
    },
    addFAQ() {
      this.Faqs.push({
        Description: '',
        Title: '',
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
